class SearchTabs {
    constructor() {
        this.init();
    }

    init() {
        this.setupTabSwitching();
    }

    setupTabSwitching() {
        const tabs = document.querySelectorAll(".search__tabs__tab");

        tabs.forEach((tab) => {
            tab.addEventListener("click", (e) => {
                const targetPanelId = tab.getAttribute("aria-controls");
                this.switchTab(tab, targetPanelId);
            });
        });
    }

    switchTab(activeTab, targetPanelId) {
        // Remove active state from all tabs
        document.querySelectorAll(".search__tabs__tab").forEach((tab) => {
            tab.classList.remove("search__tabs__tab--active");
            tab.setAttribute("aria-selected", "false");
        });

        // Remove active state from all panels
        document.querySelectorAll(".search__tabs__panel").forEach((panel) => {
            panel.classList.remove("search__tabs__panel--active");
        });

        // Activate the clicked tab
        activeTab.classList.add("search__tabs__tab--active");
        activeTab.setAttribute("aria-selected", "true");

        // Show the corresponding panel
        const targetPanel = document.getElementById(targetPanelId);
        if (targetPanel) {
            targetPanel.classList.add("search__tabs__panel--active");
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new SearchTabs();
});

export default SearchTabs;
